module.exports = __webpack_public_path__ + "static/media/farm-404.bb758cb1.png";